import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    path: '/transporte/trarelatoriotransporte',
    name: 'trarelatoriotransporte',
    description: 'Relatórios de Transporte',
    component: () => import('@/views/transporte/trarelatoriotransporte/Configuracao.vue'),
    meta: { permissions: [eTipoPermissao.RELATORIODEVEICULOSNOVO_MENU_1100200599] },
    goesToMenu: true,
  },
];
